import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

import { ADD_PAYMENT_DOCUMENTS_PATH, TABLET } from '@app/constants';
import { useWindowSize } from '@app/hooks';

export const PaymentDocumentsRegistryHeader: React.FC = () => {
  const { innerWidth } = useWindowSize();

  const label = innerWidth < TABLET ? '' : 'Создать счёт';

  return (
    <Link to={ADD_PAYMENT_DOCUMENTS_PATH}>
      <Button type="primary" icon={<PlusOutlined />} data-testid="add-branch">
        {label}
      </Button>
    </Link>
  );
};
